var Handlebars = require("../../../../../node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<div class=\"data-fiscal\">\r\n    <hr class=\"separador-gris\">\r\n    <a href=\"http://qr.afip.gob.ar/?qr=HJMakbCpenWNdXYfqXtEDQ,,\" target=\"_F960AFIPInfo\">\r\n    </a>\r\n</div>";
},"useData":true});


//////////////////
// WEBPACK FOOTER
// ./Statics/scripts/paywall/views/partials/dataFiscal.hbs
// module id = 518
// module chunks = 0